import { NavBar, AutoCenter, ActionSheet } from 'antd-mobile'

import { 
    BodyView,
    InputView,
    ButtonView,
    NavBarTitleView,
    DividerOptionView
} from "../factory/ViewUtil";
import { 
    ClockCircleOutline,
    DownFill,
} from 'antd-mobile-icons';
import React, { useEffect, useState } from 'react';
import { AssetsGetName, AssetsListener, AssetsListenerRemove } from '../assets/AssetsManager';
import { isLogin, PostWithdraw, RequestWithdraw } from '../../NetworkFactory';
import { BigDecimalZero, DecimalComparedToZero, DecimalZero, FullURL, ToastClear, ToastContent, ToastLoading } from '../factory/FactoryUtil';

const WithdrawViewController = ({goback, data}) => {

    const {type = '1'} = data
    const [dataSource, setDataSource] = useState([]);
    const [dataIndex, setDataIndex] = useState(0);
    const [protocolIndex, setProtocolIndex] = useState(0);
    const [available, setAvailable] = useState('0.00');
    const [assetsData, setAssetsData] = useState([]);
    const [reality, setReality] = useState('0.00');
    
    const [trc20Data, setTrc20Data] = useState([]);
    const [erc20Data, setErc20Data] = useState([]);
    
    const backError = () => {
        ToastContent('Error')
        goback()
    }

    useEffect(() => {
        if(isLogin()) {
            ToastLoading('Loading...')
            RequestWithdraw().then(response => {
                ToastClear()
                const data = response.data.data || []
                let tempData = []
                data.forEach(item => {
                    let draw_supports = item.draw_supports || ''
                    if(draw_supports.length !== 0) {
                        item['protocol'] = draw_supports.split(',')
                        if(item.protocol.length === 2) {
                            tempData.push(item)
                        }
                    }
                })
                setErc20Data(response.data['erc20']??[])
                setTrc20Data(response.data['trc20']??[])
                if(tempData.length === 0) {
                    backError()
                }
                else {
                    setDataSource(tempData)
                }
            }).catch(()=> {
                backError()
            })
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps


    useEffect(() => {
        if(isLogin()) {
            AssetsListener(type, 'WithdrawViewController', response => {
                setAssetsData(response.data || [])
            })
            return () => {
                AssetsListenerRemove(type, 'WithdrawViewController')
            }
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if(dataSource.length > 0 && assetsData.length > 0) {
            const symbol = dataSource[dataIndex].symbol
            for(let i = 0; i<assetsData.length;i++) {
                const item = assetsData[i]
                if(item.symbol === symbol) {
                    setAvailable(item.available)
                    break
                }
            }
        }
    }, [dataSource, assetsData, dataIndex]) // eslint-disable-line react-hooks/exhaustive-deps

    const onChange = () => {
        setAddress('')
        setProtocolIndex(protocolIndex === 0 ? 1 : 0)
    }

    const selectSymbol = () => {
        let actions = []
        dataSource.forEach(item => {
            actions.push({
                key : item.symbol,
                text : item.symbol
            })
        })
        const handler = ActionSheet.show(
            {
                extra : <div style={{textAlign : 'center'}}><div style={{color : '#000', fontSize : '18px', marginBottom : '6px'}}>Please select currency</div><div>Withdraw channel</div></div>,
                cancelText : 'Cancel',
                actions : actions,
                onAction : (_, index) => {
                    handler.close()
                    setDataIndex(index)
                    setProtocolIndex(0)
                }
            }
        )
    }

    const [address, setAddress] = useState('')
    const [withdrawQuantity, setWithdrawQuantity] = useState('')
    const [password, setPassword] = useState('')

    // # 提交
    const postWithdraw = () => {
        const code = dataSource[dataIndex].protocol[protocolIndex] || ''
        const symbol = dataSource[dataIndex].symbol || ''
        if(symbol.length === 0 || code === 0) {
            ToastContent('Invalid currency or protocol code')
            return
        }
        if(address.length < 6) {
            ToastContent('Your wallet address is invalid')
            return
        }
        
        if(DecimalComparedToZero(withdrawQuantity) <= 0) {
            ToastContent('Invalid Withdraw quantity')
            return
        }

        const amount = BigDecimalZero(withdrawQuantity)
        if(amount.comparedTo(BigDecimalZero(available)) > 0) {
            ToastContent('Insufficient Balance')
            return
        }

        if(password.length !== 6) {
            ToastContent('Invalid payment password')
            return
        }
        ToastLoading('Withdrawing...')
        const data = {
            account : type,
            address : address,
            amount : amount.toString(),
            password : password,
            symbol : symbol,
            symbol_code : code
        }
        PostWithdraw(data).then(response => {
            const {status} = response.data || {}
            if(status === 200) {
                ToastContent('Submitted for review')
                goback()
            }
            else if(status === -10) {
                ToastContent('Insufficient withdrawal balance')
            }
            else if(status === -11) {
                ToastContent('Withdrawal amount exceeds balance')
            }
            else if(status === -21) {
                ToastContent('No payment password set')
            }
            else if(status === -22) {
                ToastContent('Payment password error')
            }
            else {
                ToastContent('Withdrawal exception')
            }

        }).catch(()=> {
            ToastContent('Withdrawal exception')
        })
        console.log(data);
        
    }

    const commission = () => {
        let draw_rate = BigDecimalZero(dataSource[dataIndex].draw_rate)
        if(draw_rate.comparedTo(DecimalZero()) > 0) {
            return draw_rate.mul(BigDecimalZero('100')).toString()
        }
        return '0.00'
    }

    const onClickAll = () => {
        setWithdrawQuantity(available)
        updateCommission(available)
    }

    const updateCommission = (amount) => {
        if(DecimalComparedToZero(amount) > 0) {
            let draw_rate = BigDecimalZero(dataSource[dataIndex].draw_rate)
            if(draw_rate.comparedTo(DecimalZero()) > 0) {
                setReality(BigDecimalZero(amount).mul(draw_rate).toString())
            }
        }
    }

    const openHistory = () => {
        try {
            const temp = dataSource[dataIndex].protocol[protocolIndex]
            let actions = []
            if(temp === 'TRC20') {
                trc20Data.forEach(item => {
                    actions.push({
                        key : item,
                        text : <div style={{wordBreak : 'break-all'}}>{item}</div>
                    })
                })
            } else if(temp === 'ERC20') {
                erc20Data.forEach(item => {
                    actions.push({
                        key : item,
                        text : <div style={{wordBreak : 'break-all'}}>{item}</div>
                    })
                })
            }
            if(actions.length === 0) {
                ToastContent('No address record')
                return
            }
            const handler = ActionSheet.show(
                {
                    extra : <div style={{textAlign : 'center'}}><div style={{color : '#000', fontSize : '18px', marginBottom : '6px', color : '#666'}}>Historical records</div></div>,
                    cancelText : 'Cancel',
                    actions : actions,
                    onAction : (item, index) => {
                        handler.close()
                        setAddress(item.key)
                    }
                }
            )

        } catch {}
       
    }

    return(
        <>
             <div className='fixed-nav-bar'>
                <NavBar onBack = {goback}>
                    {
                        dataSource.length > 0 ? (<NavBarTitleView 
                            onClick={selectSymbol} 
                            src={FullURL(dataSource[dataIndex].logo)}
                            icon={<DownFill 
                            fontSize={10}/>}>{dataSource[dataIndex].symbol}</NavBarTitleView>) : ''
                    }
                </NavBar>
            </div>
            {
                dataSource.length > 0 ? (<BodyView style={{ padding : '0 10px', paddingTop : '52px'}}>
                    <AutoCenter style={{display : 'block', marginTop : '10px'}}>
                        {AssetsGetName(type)} usable {dataSource[dataIndex].symbol} Withdraw
                    </AutoCenter>
                    <AutoCenter style={{display : 'block', fontSize : '22px', fontWeight : 'bold', margin : '10px 0 30px 0'}}>
                        {available} $
                    </AutoCenter>
                    <InputView isBottomBorder={false} title = "Wallet Address" clearable value={address} onChange={val => {setAddress(val)}}
                        right={
                            <div style={{marginTop : 4, lineHeight : 0}}><ClockCircleOutline onClick={openHistory}/></div>
                        }
                    />
                    {
                        dataSource.length > 0 ? (<DividerOptionView 
                            left={protocolIndex === 0} 
                            onChange={onChange} 
                            leftText={dataSource[dataIndex].protocol[0]}
                            rightText={dataSource[dataIndex].protocol[1]}
                            topBorder={false}/>) : ''
                    }
    
                    <div style={{height : '20px'}}></div>
                    <InputView title = "Withdraw quantity" clearable value={withdrawQuantity} onChange={val => {setWithdrawQuantity(val);updateCommission(val)}}/>
                    <AutoCenter className="tipHeaderTitle" style={{marginBottom : '30px'}}>
                        Balance: {available} {dataSource[dataIndex].symbol} <b onClick={onClickAll}>Withdraw All</b>
                    </AutoCenter>
                    
                    <InputView title = "Password" clearable value={password} type='password' onChange={val => {setPassword(val)}}/>
                    <div style={{height : '20px'}}></div>
                    <ButtonView onClick={postWithdraw}>Withdraw</ButtonView>
                    <AutoCenter className="tipHeaderTitle">
                        Commission: {commission()}% {dataSource[dataIndex].symbol} Reality {reality} {dataSource[dataIndex].symbol}
                    </AutoCenter>
                </BodyView>) : ''
            }
        </>
    );
}
export default React.memo(WithdrawViewController)